import styled from 'styled-components';

import { Box } from '~/components/Box';
import { Button } from '~/components/Button';

export const Footer = styled(Box)`
  text-align: right;
  margin-top: auto;
  padding-top: ${({ theme }) => theme.space.gridGap};

  ${Button} + ${Button} {
    margin-left: ${({ theme }) => theme.space[3]};
  }
`;
try {
    // @ts-ignore
    Footer.displayName = "Footer";
    // @ts-ignore
    Footer.__docgenInfo = { "description": "", "displayName": "Footer", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Modal/Footer/index.tsx#Footer"] = { docgenInfo: Footer.__docgenInfo, name: "Footer", path: "src/components/Modal/Footer/index.tsx#Footer" };
}
catch (__react_docgen_typescript_loader_error) { }